var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a',{staticClass:"more-option",style:({'color':_vm.textColor}),on:{"click":_vm.getNow}},[_vm._v("MORE OPTIONS  >")])])}
var staticRenderFns = []

export { render, staticRenderFns }